export function getCookieDomain() {
    const host = window.location.hostname;
    if (host.endsWith('development.certn.com')) {
        // staging preview cluster
        return '.development.certn.com';
    }
    if (host.endsWith('certn.co')) {
        // prod
        return '.certn.co';
    }
    // fallback to host-only cookies on localhost, etc.
    return host;
}
